import {
  Loader,
  Select,
  SelectItem,
  SelectSearch,
} from '@energybox/react-ui-library/dist/components';
import {
  AcPowerSystem,
  PowerMeteringType,
} from '@energybox/react-ui-library/dist/types';
import { hasSubstr } from '@energybox/react-ui-library/dist/utils';

import React from 'react';
import { connect } from 'react-redux';
import { getAcPowerSystems } from '../../actions/app';
import { ApplicationState } from '../../reducers';

interface OwnProps {
  onSelect: (acPowerId: string) => void;
  value?: string;
  error: boolean;
  disabled?: boolean;
  powerMeteringType: PowerMeteringType;
}

interface Props extends OwnProps {
  getAcPowerSystems: typeof getAcPowerSystems;
  acPowerSystems?: AcPowerSystem[];
}

interface State {
  search: string;
}

class SelectAcPowerSystem extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      search: '',
    };
  }

  searchChange(e: React.FormEvent<HTMLInputElement>) {
    this.setState({
      search: e.currentTarget.value,
    });
  }

  resetSearch() {
    this.setState({ search: '' });
  }

  componentDidMount() {
    const { acPowerSystems, getAcPowerSystems } = this.props;
    if (!acPowerSystems) getAcPowerSystems();
  }

  filterOptions = (acPowerSystems: AcPowerSystem[]) => {
    const { powerMeteringType } = this.props;

    if (powerMeteringType === PowerMeteringType.REAL) {
      return acPowerSystems.filter(item => item.virtual === false);
    }

    //virtual acPowerSystems have a null energySource
    return acPowerSystems.filter(item => item.virtual === true);
  };

  render() {
    const { acPowerSystems, value, onSelect, error, disabled } = this.props;

    if (!acPowerSystems) {
      return <Loader size={12} />;
    } else {
      const { search } = this.state;
      const filteredAcPowerSystems = this.filterOptions(acPowerSystems);

      const listedAcPowerSystems = (filteredAcPowerSystems || []).filter(
        (eq: AcPowerSystem) => {
          if (search.length <= 2) return true;
          return hasSubstr(eq.title, search);
        }
      );

      const selectedAcPowerSystem = filteredAcPowerSystems.find(
        acPowerSystem => acPowerSystem.id === value
      );

      return (
        <Select
          disabled={disabled}
          variant={'select'}
          onClick={this.resetSearch.bind(this)}
          title={selectedAcPowerSystem?.title}
          value={selectedAcPowerSystem?.id}
          error={error}
        >
          <SelectSearch
            onChange={this.searchChange.bind(this)}
            value={search}
          />
          {listedAcPowerSystems.map((eq: AcPowerSystem) => (
            <SelectItem
              key={eq.id}
              isSelected={eq.id === selectedAcPowerSystem?.id}
              onSelect={() => onSelect(eq.id)}
            >
              {eq.title}
            </SelectItem>
          ))}
        </Select>
      );
    }
  }
}

const mapStateToProps = ({ app }: ApplicationState) => ({
  acPowerSystems: app.acPowerSystems,
});

const mapDispatchToProps = {
  getAcPowerSystems,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectAcPowerSystem);
